import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToAnchor } from "@/lib/scrollToAnchor";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Hash-Anker (z. B. /#preise) – robust scrollen, da Sektion ggf. lazy mountet
      const id = hash.replace(/^#/, "");
      if (id) {
        scrollToAnchor(id);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
